import { css } from '@emotion/react';

import { fontWeights, screens } from '../shared/styles';

const mdUp = `@media (min-width: ${screens.md})`;

export const rootStyles = css`
  width: 100%;
`;

/**
 * `auto` is compact until the md breakpoint, then horizontal.
 * `display: none` also removes the inactive layout from the accessibility tree.
 */
export const autoRootStyles = css`
  & [data-layout='horizontal'] {
    display: none;
  }

  ${mdUp} {
    & [data-layout='horizontal'] {
      display: flex;
    }

    & [data-layout='compact'] {
      display: none;
    }
  }
`;

export const horizontalListStyles = css`
  align-items: center;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;

export const horizontalItemStyles = css`
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  min-width: 0;

  &:last-child {
    flex: 0 0 auto;
  }

  &:not(:last-child)::after {
    background: var(--color-primary-100);
    content: '';
    flex: 1 1 auto;
    height: 1px;
    margin-inline: var(--spacing-3);
    min-width: var(--spacing-4);
  }
`;

export const stepStyles = css`
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: var(--spacing-2);
  min-width: 0;
`;

export const markerStyles = css`
  align-items: center;
  background: transparent;
  border: 1.5px solid var(--color-primary-100);
  border-radius: var(--radius-round);
  box-sizing: border-box;
  color: var(--color-hunter-500);
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  font-weight: ${fontWeights.medium};
  height: var(--spacing-6);
  justify-content: center;
  line-height: 1;
  width: var(--spacing-6);
`;

export const markerCurrentStyles = css`
  border: 2px solid var(--color-primary-800);
  color: var(--color-primary-800);
`;

export const labelStyles = css`
  color: var(--color-hunter-400);
  white-space: nowrap;
`;

export const labelCurrentStyles = css`
  color: var(--color-primary-800);
`;

export const compactRootStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  width: 100%;
`;

export const compactListStyles = css`
  display: flex;
  gap: var(--spacing-2);
  list-style: none;
  margin: 0;
  order: 1;
  padding: 0;
  width: 100%;
`;

export const compactItemStyles = css`
  background: var(--color-primary-100);
  border-radius: var(--radius-round);
  flex: 1 1 0;
  height: var(--spacing-1);
  min-width: var(--spacing-4);
  overflow: hidden;
  position: relative;

  &[data-state='completed'],
  &[data-state='current'] {
    background: var(--color-primary-800);
  }
`;

export const progressStyles = css`
  color: var(--color-hunter-500);
  letter-spacing: 0.04em;
  margin: 0;
  order: 2;
`;

export const visuallyHiddenStyles = css`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
